
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import AddNotesForm from '../../misc/AddNotesForm'

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var saleContextUtil = require('../../../utils/saleContextUtil.js');
var stringUtil = require('../../../../../utils/string/stringUtil');
var displaySettingsUtils = require('../../../../../utils/domain/settings/displaySettingsUtils');

class NotesToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);

        this.renderNotesDialogue = this.renderNotesDialogue.bind(this);

        this.state = {};
        this.state.showNotesDialogue = false;
    }

    render()
    {
        let sale = this.props.saleContext.sale;
        
        let canEnterNotes = saleCommonUtility.canEnterNotes(sale) && this.props.saleContext.selectedItems.length <= 1;
        
        let color = "#787878";
        if (!stringUtil.isStringNullOrEmpty(sale.instructions))    
            color = "var(--colors-primary)" 
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:canEnterNotes ? 1 : 0.5, color: color}}
                        onClick={(event) =>
                        {
                            event.stopPropagation();

                            if (!canEnterNotes)
                                return; 

                            this.state.showNotesDialogue = true;
                            this.setState({});
                        }}>
                        <EditNotesIcon size="2.2vw"/>
                    </div>
                    {this.renderNotesDialogue()}
                </Fragment>)
    }

    renderNotesDialogue()
    {
        if (!this.state.showNotesDialogue)
            return null;

        let cookingInstructions = "";
        let internalNotes = "";
        let displayInternalNotes = displaySettingsUtils.getDisplayInternalNotes();


        if (this.props.saleContext.selectedItems.length > 0)
        {
            let item = this.props.saleContext.selectedItems[0];
            cookingInstructions = item.instructions;
            displayInternalNotes = false;
        }
        else
        {
            cookingInstructions = this.props.saleContext.sale.instructions;
            internalNotes = this.props.saleContext.sale.notes;
        }
        
        return <AddNotesForm cookingInstruction={cookingInstructions}
                             internalNotes={internalNotes}
                             showInternalNotes={displayInternalNotes}
                             onCancel={()=>
                            {
                                this.state.showNotesDialogue = false;
                                this.setState({})
                            }}
                            onSubmit={(result)=>
                            {
                                this.state.showNotesDialogue = false;
                                this.setState({})
                                
                                if (this.props.saleContext.selectedItems.length > 0)
                                {
                                    let item = this.props.saleContext.selectedItems[0];
                                    item.instructions = result.cookingInstruction;
                                }
                                else
                                {
                                    this.props.saleContext.sale.instructions = result.cookingInstruction;
                                    this.props.saleContext.sale.notes = result.internalNotes;
                                }

                                saleContextUtil.raiseSaleContextSaleChangeEvent(false);
                            }}/>
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(NotesToolbarButton)

const EditNotesIcon = ({size})=>{
    return (
    <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"></path>
    </svg>
    )
}